import styled from "styled-components"
import { space } from "styled-system"

const Box = styled.div`
  ${space}
`

export default Box
